import http from '@/service/http'
import {ROOT_EDUCATION, ROOT_SIMULATOR, ROOT_RESOURCE, ROOT_OMS} from './urlConfig'



//获取用户信息
export const getUserInfo = ()=>{
    return http.get(ROOT_SIMULATOR+'/api/common/userinfo')
}

//获取租户列表
export const getTenantList = (params?:object)=>{
    return http.post(ROOT_SIMULATOR+'/api/common/myCorps',params)
}

//设置当前租户
export const setCurrentTenant = (params:object)=>{
    return http.post(ROOT_SIMULATOR+'/api/common/switchCorp',null,{query:params})
}

//埋点统计
export const trackStatistic = (params:object)=>{
    return http.post(ROOT_SIMULATOR+'/api/common/app/event',params)
}

//输电导出报告
export const exportAirLinePointActions = (params:object)=>{
    return http.post(ROOT_SIMULATOR+'/api/training/exportAirLinePointActions', params,{responseType:'blob'})
}

//获取logo图片
export const getCorpLogoUrl = (params:object)=>{
    return http.post(ROOT_SIMULATOR+'/api/common/getCorpLogoUrl', params)
}

//缺陷认识-获取设备部位树
export const getDeviceDefectTree = (params:object)=>{
    return http.post(ROOT_SIMULATOR+'/api/deviceDefect/getTree', params)
}

//缺陷认识-获取部位缺陷图库
export const getDeviceDefectGallery = (params:object)=>{
    return http.post(ROOT_SIMULATOR+'/api/deviceDefect/getGallery', params)
}

//运营端 获取设备部位树
export const getOmsDeviceDefectTree = (params:object)=>{
    return http.post(ROOT_OMS+'/api/deviceDefectMgr/tree', params)
}

//运营端 获取缺陷列表
export const getOmsDeviceDefectList = (params:object)=>{
    return http.post(ROOT_OMS+'/api/deviceDefectMgr/defect/list', params)
}

//运营端 上传设备部位图片
export const uploadOmsDeviceDefectPicture = (params:object)=>{
    return http.post(ROOT_OMS+'/api/deviceDefectMgr/uploadPicture', params)
}

//运营端 更新缺陷
export const updateOmsDeviceDefect = (params:object)=>{
    return http.post(ROOT_OMS+'/api/deviceDefectMgr/defect/update', params)
}


